module.exports = "<div class=\"web-view\">\n    <router-outlet></router-outlet>\n</div>"